import { createFileRoute } from '@tanstack/react-router';
import { PointQrPage } from '../pages/point-qr';

// `/p/` без идентификатора — QR с обрезанной ссылкой: та же страница в состоянии
// «не удалось распознать», а не «Not Found» роутера.
export const Route = createFileRoute('/p/')({
  component: () => <PointQrPage pointId="" />,
});
